import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-invoice-create',
  templateUrl: './app-project-invoice-create.component.html',
  styleUrls: ['./app-project-invoice-create.component.scss']
})
export class AppProjectInvoiceCreateComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
